import * as React from "react"
import "./we.css"
import {Link} from "gatsby"
import we from "../../../images/we.webp"

const We = ({isHomePage}) => {
    return (
        <section className="wrapper bg-light">
            <div className="container py-8 py-md-12">
                <div className="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
                    <div className="pt-4 row grid-view col-lg-5 order-lg-2 d-flex position-relative mx-auto">
                        <div
                            data-sal="slide-left"
                            data-sal-delay="400"
                            data-sal-easing="easeInExpo"
                            className="img-blob rounded"
                        >
                            <img src={we} alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-6 text-center text-lg-start">
                        <h2
                            data-sal="slide-down"
                            data-sal-delay="100"
                            data-sal-easing="easeInExpo"
                            className="display-1 mb-3"
                        >
                            Who Are We?
                        </h2>
                        <p
                            data-sal="slide-down"
                            data-sal-delay="200"
                            data-sal-easing="easeInExpo"
                            className="lead fs-lg"
                        >
                            We are the pioneers of
                            manufacturing polypropylene spun bonded nonwoven fabric and its
                            products in India and are IKEA approved suppliers.
                        </p>
                        <p
                            data-sal="slide-down"
                            data-sal-delay="300"
                            data-sal-easing="easeInExpo"
                            className="lead fs-lg"
                            className="mb-6 fs-18"
                        >
                            Texbond has expanded its capacity, developed a skilled workforce and
                            introduced integrated technologies, to remain globally up-to-date. It is
                            truly an organization with a glorious past and a bright future.
                        </p>
                        {
                            isHomePage &&
                            <div className="pt-1">
                                <Link to="/about" className="btn btn-orange btn-lg rounded-pill">More About Us</Link>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default We